import * as L from 'leaflet';
import convert from 'color-convert';

require('leaflet.pattern/dist/leaflet.pattern');

function darken(hex: string) {
  if (hex === 'rgba(0,0,0,0)') {
    return hex;
  }

  const hsl = convert.hex.hsl(hex);
  hsl[2] *= 0.3;

  const darkened = convert.hsl.hex(hsl);
  return '#' + darkened;
}

export class StripePatternFactory {
  static generateDiagonalWithColor(color: string) {
    const newPatternType = (L as any).Pattern.extend({
      options: {
        color: color,
        spaceColor: darken(color),
        opacity: 1.0,
        spaceOpacity: 1.0,
        patternContentUnits: 'objectBoundingBox',
        patternUnits: 'objectBoundingBox',
        weight: 0.1,
        spaceWeight: 0.1,
        height: 0.2,
        angle: -45,
      },

      _addShapes: function () {
        this._stripe = new (L as any).PatternPath({
          stroke: true,
          weight: this.options.weight,
          color: this.options.color,
          opacity: this.options.opacity,
        });

        this._space = new (L as any).PatternPath({
          stroke: true,
          weight: this.options.spaceWeight,
          color: this.options.spaceColor,
          opacity: this.options.spaceOpacity,
        });

        this.addShape(this._stripe);
        this.addShape(this._space);

        this._update();
      },

      _update: function () {
        this._stripe.options.d = 'M0 ' + this._stripe.options.weight / 2 + ' H ' + this.options.width;
        this._space.options.d = 'M0 ' + (this._stripe.options.weight + this._space.options.weight / 2) + ' H ' + this.options.width;
      },

      setStyle: (L as any).Pattern.prototype.setStyle,
    });

    return new newPatternType();
  }
  static generateThickHorizontalWithColor(color: string) {
    const newPatternType = (L as any).Pattern.extend({
      options: {
        color: color,
        spaceColor: darken(color),
        opacity: 1.0,
        spaceOpacity: 1.0,
        patternContentUnits: 'objectBoundingBox',
        patternUnits: 'objectBoundingBox',
        weight: 0.05,
        spaceWeight: 0.15,
        height: 0.2,
      },

      _addShapes: function () {
        this._stripe = new (L as any).PatternPath({
          stroke: true,
          weight: this.options.weight,
          color: this.options.color,
          opacity: this.options.opacity,
        });

        this._space = new (L as any).PatternPath({
          stroke: true,
          weight: this.options.spaceWeight,
          color: this.options.spaceColor,
          opacity: this.options.spaceOpacity,
        });

        this.addShape(this._stripe);
        this.addShape(this._space);

        this._update();
      },

      _update: function () {
        this._stripe.options.d = 'M0 ' + this._stripe.options.weight / 2 + ' H ' + this.options.width;
        this._space.options.d = 'M0 ' + (this._stripe.options.weight + this._space.options.weight / 2) + ' H ' + this.options.width;
      },

      setStyle: (L as any).Pattern.prototype.setStyle,
    });

    return new newPatternType();
  }
  static generateThickVerticalWithColor(color: string) {
    const newPatternType = (L as any).Pattern.extend({
      options: {
        color: color,
        spaceColor: darken(color),
        opacity: 1.0,
        spaceOpacity: 1.0,
        patternContentUnits: 'objectBoundingBox',
        patternUnits: 'objectBoundingBox',
        weight: 0.05,
        spaceWeight: 0.15,
        height: 0.2,
        angle: 90,
      },

      _addShapes: function () {
        this._stripe = new (L as any).PatternPath({
          stroke: true,
          weight: this.options.weight,
          color: this.options.color,
          opacity: this.options.opacity,
        });

        this._space = new (L as any).PatternPath({
          stroke: true,
          weight: this.options.spaceWeight,
          color: this.options.spaceColor,
          opacity: this.options.spaceOpacity,
        });

        this.addShape(this._stripe);
        this.addShape(this._space);

        this._update();
      },

      _update: function () {
        this._stripe.options.d = 'M0 ' + this._stripe.options.weight / 2 + ' H ' + this.options.width;
        this._space.options.d = 'M0 ' + (this._stripe.options.weight + this._space.options.weight / 2) + ' H ' + this.options.width;
      },

      setStyle: (L as any).Pattern.prototype.setStyle,
    });

    return new newPatternType();
  }
}
